import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { TextInputForm, Calender } from "../components/Forms";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { PageHead } from "../components/PageTitle";
import API_DOMAIN from "../config/config";
import { LoadingSpinner } from "../components/Forms";

const ProductTablehead = ["S.No", "Product Name", "Price", "Action"];

const ProductList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [userData, setUserData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const fetchData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const requestBody = { search_text: searchText };
      if (fromDate && toDate) {
        requestBody.from_date = fromDate;
        requestBody.to_date = toDate;
      }
      const response = await fetch(
        `${API_DOMAIN}/products.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch data");

      const responseData = await response.json();
      if (responseData.status === 200 && Array.isArray(responseData.data)) {
        const formattedData = responseData.data.map((item) => ({
          ...item,
          values: [
            item.product_name,
            item.hsn_no || "-",
            item.item_code || "-",
            item.unit_rate || 0,
            item.item_gst || 0,
            item.crt_stock || 0,
          ],
        }));
        setUserData(formattedData);
        setLoading(false);
      } else {
        throw new Error(responseData.msg || "Invalid response");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchText, fromDate, toDate]);

  const handleRefresh = () => {
    setSearchText("");
    setFromDate("");
    setToDate("");
    fetchData();
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const session = localStorage.getItem("session");
    if (!session) {
      setIsLoggedIn(false);
    }
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading ProductList..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12" className="py-1">
            <div className="main my-2">
              <Row className="mx-2">
                <Col lg="3">
                  <div className="mx-2">
                    <TextInputForm
                      placeholder={"Search by Product Name"}
                      onChange={(e) => setSearchText(e.target.value)}
                      prefix_icon={<FaMagnifyingGlass />}
                      labelname={"Search"}
                    />
                  </div>
                </Col>

                <Col lg="9" className="d-flex justify-content-end">
                  <div className="text-end">
                    <Buttons
                      lable={<>Add New</>}
                      onClick={() => navigate("/console/item/create")}
                    />
                  </div>
                </Col>
              </Row>
              <div className="py-2 c-table">
                <TableUI
                  headers={ProductTablehead}
                  body={userData}
                  type="itemsproduct"
                  pageview={"yes"}
                  onDelete={fetchData}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductList;

